import { useEffect } from "react"
import Value from "aldoo-ra/Value"

const platformMapping = {
  ios: "ios",
  android: "android",
  windows: "android",
  linux: "android", // Maps linux to windows in the site platform
  mac: "ios",
  unknown: "android",
}

const PlatformManager = () => {
  const [detectedPlatform] = Value({
    key: "detected_platform",
  })

  const [sitePlatform, setSitePlatform] = Value({
    key: "site_platform",
    persistKey: "site_platform",
  })

  useEffect(() => {
    // Check URL platform override
    const pathname = window.location.pathname
    const pathSegments = pathname.split('/').filter(Boolean)

    // Check if first segment is a language code (2-letter code)
    const hasLangCode = pathSegments[0]?.length === 2 && pathSegments[0].match(/^[a-z]{2}$/)

    // Get platform from URL - it's either first segment or second (after language)
    const platformIndex = hasLangCode ? 1 : 0
    const urlPlatform = pathSegments[platformIndex]

    let resolvedPlatform
    // Set site platform based on URL or mapped detected platform
    if (platformMapping[urlPlatform]) {
      resolvedPlatform = platformMapping[urlPlatform]
    } else {
      resolvedPlatform = platformMapping[detectedPlatform]
    }

    setSitePlatform(resolvedPlatform)

    // Don't redirect to platform URLs anymore - keep users on home page
    // Platform-specific pages have been removed
  }, [detectedPlatform])

  return null
}

export default PlatformManager